import { createTheme } from "@mui/material";

export const customTheme = createTheme({
  cssVariables: {
    colorSchemeSelector: "data-toolpad-color-scheme",
  },
  components: {
    // Name of the component
    MuiList: {
      styleOverrides: {
        root: {
          "& .MuiListItem-root": {
            "& .MuiListItemButton-root.Mui-selected": {
              backgroundColor: "#42a5f52e",

              "& .MuiListItemText-root": {
                "& .MuiTypography-root": {
                  color: "#4091d2",
                },
              },
              "& .MuiListItemIcon-root": {
                "& .MuiSvgIcon-root": {
                  color: "#4091d2",
                  border: "2px solid #32cd32",
                },
              },
            },
          },
          //subheader
          "& .MuiListSubheader-root": {
            color: "#8f9dac",
            paddingBottom: "47px",
            textTransform: "uppercase",
          },
        },
      },
    },

    MuiChip: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: "#2e7d32",
        },
        colorSecondary: {
          backgroundColor: "#42a5f5",
        },
      },
    },
  },
  colorSchemes: {
    light: {
      palette: {
        background: {
          //default: "#F9F9FE",
          default: "#f1f5f9", // #EEEEF9
          paper: "#ffffff",
        },
      },
    },
    dark: {
      palette: {
        background: {
          default: "#2A4364",
          paper: "#112E4D",
        },
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 600,
      lg: 1200,
      xl: 1536,
    },
  },
});
